var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoMobileComments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F5A87F15-F160-4CB4-A888-DF78EE2084C7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.1570102,9.17783322 L0,9.17783322 L0,0.000333333325 L12.5,0.000333333325 L12.5,9.17783322 L5.3429898,9.17783322 L3.75,10.7565923 L2.1570102,9.17783322 Z M2.8429898,7.51116668 L3.75,8.41007426 L4.6570102,7.51116668 L10.8333333,7.51116668 L10.8333333,1.667 L1.66666667,1.667 L1.66666667,7.51116668 L2.8429898,7.51116668 Z M14.1666667,5.83333323 L14.1666667,4.16666661 L16.6497501,4.16666661 L16.6497501,14.1666663 L14.5118447,14.1666663 L12.9166667,15.7618443 L11.3214887,14.1666663 L5,14.1666663 L5,10.8333331 L6.66666668,10.8333331 L6.66666668,12.4999997 L12.0118447,12.4999997 L12.9166667,13.4048217 L13.8214888,12.4999997 L14.9830834,12.4999997 L14.9830834,5.83333323 L14.1666667,5.83333323 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Article",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-Article",
    transform: "translate(-273.000000, -1824.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(121.000000, 1822.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "like",
    transform: "translate(151.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_conversation"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(1.666667, 2.500000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#191919",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMobileComments);
export default __webpack_public_path__ + "static/media/ico_mobile_comments.d8a52d7eb9b6987531e492d82584558a.svg";
export { ForwardRef as ReactComponent };